export default "__VITE_ASSET__C63NbBeZ__"